if (!global._babelPolyfill) {
    require("babel-polyfill");
}

import React from "react";
import { connect } from "react-redux";

import * as actionTypes from "../actions/actionTypes";
let actions = require("../actions/actions");

export class DenyIconModal extends React.Component {
    componentWillMount() {
        this.props.denialReasons();
    }

    selectReason(e) {
        e.preventDefault();

        let reasons = [],
            selectedReason;

        Object.assign(
            {},
            this.props.reasons,
            this.props.reasons.forEach(reason => {
                if (reason.text === e.target.text) {
                    e.target
                        .getAttribute("class")
                        .split(" ")
                        .forEach(className => {
                            if (className === "disabled") {
                                reason.selected = false;
                            } else {
                                reason.selected = true;
                            }
                        });
                }
                reasons.push(reason);
            })
        );

        this.setState({
            reasons: reasons
        });
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.result.actionType === actionTypes.DENY_ICONS_SUCCESS) {
            if (this.findIconsToDeny(this.props.icons) === 0) {
                this.props.dismissModal();
            }
        }
    }

    constructor(props) {
        super(props);

        this.state = { fireDenialAction: false };
    }

    denyIcon() {
        let customText = this.refs["reason-custom"].value,
            denialReasons = [];

        if (this.props.reasons) {
            this.props.reasons.forEach(reason => {
                if (reason.selected) {
                    denialReasons.push(reason.text);
                }
            });
        }

        if (customText) {
            denialReasons.push(customText);
        }

        this.fireDenialAction(denialReasons);
        this.setState({
            fireDenialAction: true,
            selectedReasons: denialReasons
        });
    }

    dismissModal(e) {
        if (e) e.preventDefault();

        this.props.dismissModal();
    }

    findIconsToDeny(icons) {
        let iconsToDeny = [];

        icons.forEach(icon => {
            if (icon.selected) {
                iconsToDeny.push(icon.id);
            }
        });

        return iconsToDeny.length;
    }

    fireDenialAction(selectedReasons) {
        this.props.denyIcons(
            this.props.icons.filter(function(icon) {
                if (icon.selected === true) {
                    return icon;
                }
            }),
            selectedReasons
        );
    }

    render() {
        let iconsToDeny = this.findIconsToDeny(this.props.icons),
            reasons = this.renderReasons();

        return (
            <div
                className={
                    "react-modal full-transparent moderation-modal-background"
                }
            >
                <a
                    href="#"
                    className="modal-background-closer"
                    onClick={this.dismissModal.bind(this)}
                />
                <div className={"inner-modal"}>
                    <a
                        href="#"
                        onClick={this.dismissModal.bind(this)}
                        title="close"
                        className="ui_close"
                    />
                    <div className="modal-content">
                        <h3 className="modal-title">{"Deny Icons"}</h3>
                        <p className="gray">
                            {
                                "Select one or more of the following reasons for denial:"
                            }
                        </p>
                        <div
                            className="list-group"
                            style={{
                                maxHeight: "350px",
                                overflow: "scroll",
                                borderBottom: "inherit"
                            }}
                        >
                            {reasons}
                        </div>
                        <textarea
                            ref="reason-custom"
                            placeholder="Add custom response..."
                        />
                        <button
                            className="btn btn-default black"
                            style={{ padding: "10px 80px", margin: "30px 0" }}
                            onClick={this.denyIcon.bind(this)}
                        >
                            {"Deny (" + iconsToDeny + ") Icons"}
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    renderReasons() {
        let reasons = [];

        if (this.props.reasons) {
            this.props.reasons.forEach(reason => {
                reasons.push(
                    <a
                        key={reason.ref}
                        className={`list-group-item ${
                            reason.selected ? "disabled" : ""
                        }`}
                        href="#"
                        ref={reason.ref}
                        onClick={this.selectReason.bind(this)}
                    >
                        {reason.text}
                    </a>
                );
            });
        } else {
            reasons.push(
                <div key={"loading"} style={{ margin: "20px 0" }}>
                    {"Loading reasons..."}
                </div>
            );
        }

        return reasons;
    }
}

function mapStateToProps(state, ownProps) {
    let icons = [],
        reasons = undefined,
        upload = undefined;

    if (state.denial.reasons) {
        reasons = [];

        state.denial.reasons.forEach(reason => {
            reasons.push({
                ref: `reason-${state.denial.reasons.indexOf(reason)}`,
                text: reason,
                selected: false
            });
        });
    }

    if (state.uploads.keys) {
        state.uploads.keys.forEach(uploadId => {
            if (state.uploads[uploadId].status === "active") {
                upload = state.uploads[uploadId];

                upload.pagination = {
                    icons: state.pagination.uploadIcons[""]
                };

                upload.result = state.uploads[uploadId].result;

                if (upload.icons) {
                    upload.iconKeys.forEach(iconId => {
                        let icon = upload.icons[iconId];
                        if (icon.status !== "denied") {
                            icons.push(icon);
                        }
                    });
                }
            }
        });
    }

    if (state.uploads.error) upload = state.uploads;

    return { icons, upload, reasons };
}

export default connect(mapStateToProps, {
    denialReasons: actions.denialReasons,
    denyIcons: actions.denyIcons
})(DenyIconModal);
